import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

const FilterDropdown = ({ label, value, options, onChange, disabled = false, className = "" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel = options.find(o => String(o.value) === String(value))?.label || label;

  return (
    <div ref={ref} className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => !disabled && setOpen(!open)}
        className={`flex items-center justify-between gap-2 py-1.5 px-3 text-sm rounded-lg transition-colors ${
          disabled ? "text-gray-400 cursor-default" : "text-gray-700 cursor-pointer hover:bg-gray-50"
        }`}
        style={{
          border: open ? "2px solid #93c5fd" : "1px solid #e5e7eb",
          backgroundColor: disabled ? "#c9c9c9" : "#fff",
          minWidth: "140px",
        }}
      >
        <span className="truncate">{value ? selectedLabel : label}</span>
        <ChevronDown size={14} className={`shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="absolute top-full left-0 mt-1 bg-white rounded-xl shadow-lg py-1 z-50 min-w-full overflow-y-auto" style={{ border: "1px solid #e5e7eb", maxHeight: "450px" }}>
          {options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => { onChange(opt.value); setOpen(false); }}
              className="flex items-center gap-2 w-full px-4 py-2 text-sm text-left bg-transparent border-none cursor-pointer hover:bg-gray-50 transition-colors"
            >
              <span
                className="shrink-0"
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  border: String(value) === String(opt.value) ? "6px solid #111827" : "2px solid #d1d5db",
                  boxSizing: "border-box",
                  display: "inline-block",
                }}
              />
              <span className={`${String(value) === String(opt.value) ? "font-medium text-gray-900" : "text-gray-700"}`}>
                {opt.label}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
